import { render, staticRenderFns } from "./StockInOrderModal.vue?vue&type=template&id=6563379a&scoped=true"
import script from "./StockInOrderModal.vue?vue&type=script&lang=js"
export * from "./StockInOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6563379a",
  null
  
)

export default component.exports